
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SvgIcon',
  props: {
    // svg名字
    type: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: '1em',
    },
    color: {
      type: String,
      default: '#000',
    },
  },
  setup() {
    return {
    };
  },
});
